import { useEffect } from "react";
import { useMotionValue } from "motion/react";

export const useDrawerPosition = (isOpen: boolean) => {
  const x = useMotionValue(0);
  const y = useMotionValue(0);

  // Reset position when drawer opens
  useEffect(() => {
    if (isOpen) {
      x.set(0);
      y.set(0);
    }
  }, [isOpen, x, y]);

  return { x, y };
};
